"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BANK_CODES = void 0;
exports.BANK_CODES = {
    AACS: { name: 'Sparkasse' },
    ABBY: { name: 'Santander' },
    ABNA: { name: 'Abn Amro' },
    ACTV: { name: 'ActivoBank' },
    ADVZ: { name: 'Advanzia  Bank' },
    AGRI: { name: 'Crédit Agricole' },
    AIBK: { name: 'AIB' },
    ALBP: { name: 'Alior Bank' },
    AXAB: { name: 'AXA Banque' },
    BACR: { name: 'Credito Emiliano' },
    BAPP: { name: 'Banco Popolare' },
    BARC: { name: 'Barclays Bank' },
    BATI: { name: 'Banque Du Bâtiment Et Des Travaux Publics' },
    BBPI: { name: 'Banco BPI' },
    BBRU: { name: 'ING Belgium' },
    BBVA: { name: 'BBVA' },
    BCIT: { name: 'Intesa Sanpaolo' },
    BCMA: { name: 'Attijariwafa Bank' },
    BCOM: { name: 'Banco Comercial' },
    BCYP: { name: 'Bank Of Cyprus' },
    BDFE: { name: 'Banque de France' },
    BDUP: { name: 'Banque Dupuy' },
    BELA: { name: 'Landesbank Berlin AG' },
    BESC: { name: 'Banco Espirito Santo' },
    BFBK: { name: 'BforBank' },
    BFCO: { name: "Banque Française Commerciale De l'Océan Indien" },
    BGLL: { name: 'BGL BNP Paribas' },
    BIGB: { name: 'Bank Millennium' },
    BIKC: { name: 'BinckBank' },
    BKAU: { name: 'Bank Austria' },
    BKBK: { name: 'Bankinter' },
    BLOP: { name: 'UBI Banca' },
    BMEU: { name: 'BMCE Euroservices' },
    BMMM: { name: 'Banque Martin Maurel' },
    BNLI: { name: 'Banca Nazionale del Lavoro' },
    BNPA: { name: 'BNP Paribas' },
    BNUG: { name: 'Banque Nuger' },
    BOFA: { name: 'Bank of America' },
    BOUS: { name: 'Boursorama' },
    BPKO: { name: 'PKO Bank Polski' },
    BPOT: { name: 'bpost banque' },
    BPPI: { name: 'Poste italiane' },
    BPSM: { name: 'Banque BCP' },
    BRDE: { name: 'BRD' },
    BRED: { name: 'BRED' },
    BREX: { name: 'mBank' },
    BSAB: { name: 'Banco de Sabadell' },
    BSAV: { name: 'Banque de Savoie' },
    BSCH: { name: 'Banco Santander' },
    BSPF: { name: 'Banque Palatine' },
    BSUI: { name: 'Crédit Agricole CIB' },
    BTRL: { name: 'Banca Transilvania' },
    BUKB: { name: 'Barclays Bank' },
    BUNQ: { name: 'bunq' },
    BYLA: { name: 'BayernLB' },
    CAHM: { name: 'Bankia' },
    CAIX: { name: 'CaixaBank' },
    CCBP: { name: 'Banque Populaire' },
    CCCM: { name: 'Caixa Central de Credito Agricola Mutuo' },
    CCFR: { name: 'HSBC' },
    CCMO: { name: 'Crédit Municipal' },
    CCOP: { name: 'Crédit Coopératif' },
    CCPL: { name: 'POST Luxembourg' },
    CCRT: { name: 'Cassa Centrale Banca - Credito Cooperativo' },
    CCUT: { name: 'Crédit Municipal de Toulon' },
    CDCG: { name: 'Caisse des Dépôts et Consignations' },
    CECE: { name: 'CEC Bank' },
    CEKO: { name: 'Československá Obchodní Banka' },
    CELL: { name: 'ING Luxembourg' },
    CEPA: { name: "Caisse d'Épargne" },
    CFFR: { name: 'Crédit Foncier de France' },
    CGDI: { name: 'Banco Inter-Atlântico' },
    CHAS: { name: 'JPMorgan Chase' },
    CIMM: { name: 'CIM Banque' },
    CITI: { name: 'Citibank' },
    CLJU: { name: 'Clear Junction' },
    CMBR: { name: 'Crédit Mutuel Arkéa' },
    CMCI: { name: 'Crédit Mutuel - CIC' },
    COBA: { name: 'Commerzbank' },
    COUR: { name: 'Banque Courtois' },
    CREG: { name: 'CBC Banque' },
    CRES: { name: 'Crédit suisse' },
    CRLY: { name: 'LCL' },
    DABA: { name: 'Danske Bank' },
    DEKT: { name: 'Deutsche Kontor Privatbank' },
    DELU: { name: 'Banque Delubac & Cie' },
    DEUT: { name: 'Deutsche Bank' },
    DGPB: { name: 'VerbundVolksbank' },
    DRES: { name: 'Dresdner Bank' },
    EPBF: { name: 'EPBF' },
    EPMT: { name: 'ePayments Systems' },
    ERBK: { name: 'Eurobank Ergasias' },
    ESCB: { name: 'Banque Wormser Frères' },
    ESPC: { name: 'Banco Santander' },
    ESSE: { name: 'SEB Group' },
    ETHN: { name: 'National Bank of Greece' },
    EVIU: { name: 'Paysera LT' },
    FDDO: { name: 'Fidor Bank' },
    FEMA: { name: 'Ferratum Bank' },
    FIDC: { name: 'Banque Fiducial' },
    FPEL: { name: 'Financière des Paiements Électroniques' },
    FTNO: { name: 'Fortuneo' },
    FXBB: { name: 'iBanFirst' },
    GEBA: { name: 'BNP Paribas Fortis' },
    GENO: { name: 'GENO BANK' },
    GIBA: { name: 'Erste' },
    GKCC: { name: 'Dexia Bank' },
    GOPS: { name: 'Kreissparkasse Goppingen' },
    GPBA: { name: 'Groupama Banque' },
    HABA: { name: 'Swedbank' },
    HBUK: { name: 'HSBC' },
    HBWE: { name: 'MagNet Bank' },
    HELA: { name: 'Helaba' },
    HYVE: { name: 'HypoVereinsbank' },
    ICRA: { name: 'BCC Capaccio Paestum' },
    INGB: { name: 'ING Direct' },
    INGD: { name: 'ING-DiBa' },
    INTF: { name: 'Intercard Finance' },
    IPBS: { name: 'Permanent TSB' },
    JYBA: { name: 'Jyske Bank' },
    KOLB: { name: 'Banque Kolb' },
    KOMB: { name: 'Komerční banka' },
    KRED: { name: 'KBC Bank' },
    LAYD: { name: 'Banque Laydernier' },
    LHVB: { name: 'LHV Pank' },
    LOYD: { name: 'Lloyds Bank' },
    MALA: { name: 'Sparkassen' },
    MIDL: { name: 'HSBC' },
    MIEG: { name: 'Mistertango' },
    MKKB: { name: 'MKB Bank' },
    MONT: { name: 'Monte Paschi Banque' },
    MPAY: { name: 'MANGOPAY' },
    MPIO: { name: 'Banco Montepio' },
    MPOS: { name: 'myPOS' },
    MRNG: { name: 'Morning' },
    NATX: { name: 'Natixis' },
    NDEA: { name: 'Nordea Bank' },
    NICA: { name: 'Crelan' },
    NOLA: { name: 'Sparkasse' },
    NORD: { name: 'Crédit du Nord' },
    NOVU: { name: 'Max' },
    NSMB: { name: 'Neuflize OBC' },
    NTSB: { name: 'N26' },
    NWBK: { name: 'NatWest' },
    OBKL: { name: 'Oberbank' },
    OPSP: { name: 'Olkypay' },
    OTPV: { name: 'OTP Bank' },
    PASC: { name: 'Banca Monte dei Paschi di Siena' },
    PBNK: { name: 'Deutsche Postbank' },
    PFSR: { name: 'Prepaid Financial Services' },
    PIRB: { name: 'Piraeus Bank' },
    PKOP: { name: 'Bank Polska Kasa Opieki' },
    POFI: { name: 'PostFinance' },
    POPU: { name: 'Banco Popular Español' },
    POSO: { name: 'Banca Popolare di Sondrio' },
    PPAY: { name: 'PostePay' },
    PREU: { name: 'Banque Privée BPE ' },
    PRIV: { name: 'Barclays' },
    PRNS: { name: 'Prepaid Financial Services' },
    PRTC: { name: 'Prepay Technologies' },
    PSST: { name: 'La Banque Postale' },
    QNTO: { name: 'Qonto' },
    RABO: { name: 'Rabobank' },
    RAIF: { name: 'Raiffeisen Schweiz' },
    RALP: { name: 'Banque Rhône-Alpes' },
    RAPH: { name: 'Raphaels Bank' },
    RCBW: { name: 'Raiffeisen Bank' },
    REVO: { name: 'Revolut' },
    RNCB: { name: 'Banca Comercială Română' },
    RZBB: { name: 'Raiffeisenbank' },
    RZBC: { name: 'Raiffeisenbank' },
    RZBR: { name: 'Raiffeisenbank' },
    SBRE: { name: 'Sparkasse' },
    SELN: { name: 'Sentenial' },
    SLMP: { name: 'SlimPay' },
    SMCT: { name: 'Société Marseillaise de Crédit' },
    SOAP: { name: 'Carrefour Banque' },
    SOGE: { name: 'Société Générale' },
    SOLA: { name: 'Sparkasse' },
    SORM: { name: 'Socram Banque' },
    STBA: { name: 'Satabank' },
    STFE: { name: 'La Nef' },
    STSA: { name: 'DSK Bank' },
    SXPY: { name: 'Saxo Bank' },
    TARN: { name: 'Banque Tarneaud' },
    TOTA: { name: 'Banco Santander' },
    TRAV: { name: 'Travelex' },
    TRPU: { name: 'Trésor public' },
    TRZO: { name: 'Treezor' },
    UBRT: { name: 'Raiffeisen Bank' },
    UBSW: { name: 'UBS Switzerland' },
    UNCR: { name: 'UniCredit' },
    UTUB: { name: 'Tunisian Foreign Bank' },
    VOWA: { name: 'Volkswagen Bank' },
    WBKP: { name: 'Santander Bank' },
    WELA: { name: 'Sparkasse Neuss' },
    WIRE: { name: '' },
    WUIB: { name: 'Western Union' },
};
